export const statutWording = (state: any, language: string, paid?: boolean) => {
  if (paid) {
    return language === 'es' ? 'Pagado' : 'Payé'
  }
  if (language === "es") {
    if (state <= 1) {
      return 'Pendiente'
    } else if (state > 1 && state < 5) {
      return 'Validado'
    } else if (state === 5) {
      return 'Entregado'
    } else if (state >= 6) {
      return 'Cancelado'
    }
  } else {
    if (state <= 1) {
      return 'En attente'
    } else if (state > 1 && state < 5) {
      return 'Validée'
    } else if (state === 5) {
      return 'Livré'
    } else if (state >= 6) {
      return 'Annulée'
    }
  }
}

export const statutColor = (state: any, paid?: boolean) => {
  if (paid) {
    return '#2e7d32' // Vert pour "Payé"
  }
  if (state <= 1) {
    return '#ffc791'
    // return "#ffff00";
  } else if (state > 1 && state < 5) {
    return '#deeda1'
    // return "#00e676";
  } else if (state === 5) {
    return '#4A90E2' // Bleu pour "Livré"
  } else if (state >= 6) {
    return '#d9d9d9'
    // return "#383838";
  } else {
    return '#d9d9d9'
  }
}

export const statutTextColor = (state: any, paid?: boolean) => {
  if (state === 5 || paid) {
    return '#FFFFFF' // Texte blanc pour "Livré" et "Payé"
  }
  return '#000000' // Texte noir par défaut pour les autres status
}
